import {atom} from "recoil";
import { BookInfo, BookToc, PersonObject, TableauInfo } from "../config/types";

const defaultLibrary:any = []
const defaultBooks:BookInfo[] = []
const defaultTocs:BookToc[] = []
const defaultTableaux:TableauInfo[] = []
const defaultPersons:PersonObject[] = []

export const libraryBooks = atom({ key: "libraryBooks", default: defaultBooks })
export const libraryTocs = atom({ key: "libraryTocs", default: defaultLibrary })
export const libraryTocRecords = atom({ key: "libraryTocRecords", default: defaultLibrary })
export const libraryPersons = atom({ key: "libraryPersons", default: defaultPersons })
export const librarySchools = atom({ key: "librarySchools", default: defaultLibrary })
export const libraryRegions = atom({ key: "libraryRegions", default: defaultLibrary })
export const libraryTableaux = atom({ key: "libraryTableaux", default: defaultTableaux })
export const libraryTableauRecords = atom({ key: "libraryTableauRecords", default: defaultLibrary })
export const libraryPsnorders = atom({ key: "libraryPsnorders", default: defaultLibrary })

export const personDataLibrary = atom({ key: "personBooks", default: defaultLibrary })
export const instDataLibrary = atom({key: "instDataLibrary", default: defaultLibrary})

export const libraryRedbooks = atom({ key: "libraryRedbooks", default: defaultLibrary })
export const keepRedbooksR = atom({ key: "keepRedbooks", default: false })